import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import ROUTE_NAME from '../../routes/RouteName';
import LogoutButton from './LogoutButton';
import TopbarMore from './TopbarMore';
import Icon from '../../assets/icons/Icon';
import LanguageToggle from '../languageToggle/views/LanguageToggle';
import { useDict } from '../../contexts/LanguageContext';

const Navbar = (props) => {
    const { toggleSidebar } = props;

    const dict = useDict();

    const location = useLocation();

    const locationPath = location.pathname;

    switch (locationPath) {
        case ROUTE_NAME.FIRST_TIME_DASHBOARD:
            return (
                <div className="topbar topbar--navigation">
                    <div className="topbar__wrapper">
                        <div className="topbar__left">
                            <button
                                className="topbar__button topbar__button--mobile"
                                type="button"
                                onClick={toggleSidebar}
                            >
                                <Icon
                                    icon="Menu"
                                    className="topbar__button-icon"
                                    width="24"
                                />
                            </button>
                            <Link
                                className="topbar__logo"
                                to={ROUTE_NAME.FIRST_TIME_DASHBOARD}
                            />
                        </div>
                        <div className="topbar__right">
                            <LanguageToggle
                                selectClassName="topbar-select my-0 d-none d-sm-flex justify-content-center"
                                formClassName="topbar-language-toggle-form-container"
                                formDivClassName="topbar-language-toggle-form"
                            />
                            <LogoutButton />
                        </div>
                    </div>
                </div>
            );
        default:
            return (
                <div className="topbar topbar--navigation">
                    <div className="topbar__wrapper container">
                        <div className="topbar__left">
                            <button
                                className="topbar__button topbar__button--mobile mr-3"
                                type="button"
                                onClick={toggleSidebar}
                            >
                                <Icon
                                    icon="Menu"
                                    className="topbar__button-icon"
                                    width="24"
                                />
                            </button>
                            <Link
                                className="topbar__logo"
                                to={ROUTE_NAME.INVEST_NOW}
                            />
                        </div>
                        <nav className="topbar__nav">
                            <NavLink
                                className={({ isActive }) =>
                                    isActive
                                        ? 'topbar__nav-link topbar__nav-link-active'
                                        : 'topbar__nav-link'
                                }
                                to={ROUTE_NAME.INVEST_NOW}
                                data-cy="topbar__navLink--investNow"
                            >
                                {dict.investNow}
                            </NavLink>
                            <NavLink
                                className={({ isActive }) =>
                                    isActive
                                        ? 'topbar__nav-link topbar__nav-link-active'
                                        : 'topbar__nav-link'
                                }
                                to={ROUTE_NAME.PERFORMANCE}
                                data-cy="topbar__navLink--performance"
                            >
                                <span data-tut="performance">
                                    {dict.performance}
                                </span>
                            </NavLink>
                            <NavLink
                                className={({ isActive }) =>
                                    isActive
                                        ? 'topbar__nav-link topbar__nav-link-active'
                                        : 'topbar__nav-link'
                                }
                                to={ROUTE_NAME.PORTFOLIO}
                                data-cy="topbar__navLink--portfolio"
                            >
                                <span data-tut="portfolio">
                                    {dict.portfolio}
                                </span>
                            </NavLink>
                            <TopbarMore />
                        </nav>
                        <div className="topbar__right align-items-center">
                            <LanguageToggle
                                selectClassName="topbar-select my-0 d-none d-sm-flex justify-content-center"
                                formClassName="topbar-language-toggle-form-container"
                                formDivClassName="topbar-language-toggle-form"
                            />
                            <LogoutButton />
                        </div>
                    </div>
                </div>
            );
    }
};

export default Navbar;
